<template>
  <div>
    <listado-secciones-tabla
      :data="dataDatatable"
      :lista_modulos="listaModulos"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Select UI

import ListadoSeccionesTabla from "../../components/tablas/superadministrador/ListadoSeccionesTabla";

import { getSecciones } from "../../constants/superadministrador";

export default {
  data() {
    return {
      dataDatatable: [],
      listaModulos: [],
    };
  },
  // Función computada para acceder a variable de store
  components: {
    ListadoSeccionesTabla,
  },
  computed: {
    ...mapState("superadministrador", [
      "dataDatatableSeccionesFiltrada",
      "dataDatatableSubSeccionesFiltrada",
    ]),
  },
  //
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar", "ActionSetLoading"]),
    ...mapActions("superadministrador", [
      "actionSetDataSeccionesNombres",
      "actionSetDataSeccionesReferencias",
      "actionSetDataSeccionesModulos",
    ]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async obtenerSecciones() {
      let sql = await getSecciones();

      this.dataDatatable = sql.data_table;
      this.listaModulos = sql.modulos;

      //Filtros
      this.actionSetDataSeccionesNombres(
        Array.from(new Set(sql.lista_nombres)).sort()
      ); // Filtra solo los datos unicos de un array;
      this.actionSetDataSeccionesReferencias(
        Array.from(new Set(sql.lista_referencias)).sort()
      ); // Filtra solo los datos unicos de un array;
      this.actionSetDataSeccionesModulos(
        Array.from(new Set(sql.lista_modulos)).sort()
      ); // Filtra solo los datos unicos de un array;
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
    this.obtenerSecciones();
  },
  watch: {
    dataDatatableSeccionesFiltrada: function (_new) {
      let me = this;
      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.dataDatatable = _new;
      }
    },
  },
};
</script>

<style></style>
